import { useState, useEffect } from 'react'
import { NavLink, Link, Outlet, useMatch } from 'react-router-dom'
import { ROUTE_MAP, SOCIAL_URL } from 'constants/index'
import { ReactComponent as Logo } from 'logo.svg'
import fbDefault from 'assets/footer-fb-default.png'
import fbHover from 'assets/footer-fb-hover.png'
import igDefault from 'assets/footer-ig-default.png'
import igHover from 'assets/footer-ig-hover.png'
import ytDefault from 'assets/footer-yt-default.png'
import ytHover from 'assets/footer-yt-hover.png'
import { ReactComponent as MenuIcon } from 'assets/mini-menu-icon.svg'
import { ReactComponent as CrossIcon } from 'assets/mini-cross-icon.svg'
import lineIconColor from 'assets/line-icon-color.png'
import igIconColor from 'assets/ig-icon-color.png'
import goTop from 'assets/go-top-icon.png'
import emailIcon from 'assets/email-icon.png'
import addressIcon from 'assets/address-icon.png'
import serviceIcon from 'assets/service-icon.png'
import favicon from 'assets/favicon.ico'
import styles from './NavWrapper.module.scss'
import classNames from 'classnames'

const NavWrapper = () => {
  const [showGoTop, setShowGoTop] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const routes = Object.keys(ROUTE_MAP)
  const isMatchSub = useMatch(':main/:sub')

  const handleMenuIconClick = () => {
    setMenuOpen(prev => !prev)
  }
  const handleMenuClose = (e) => {
    if (e.target === e.currentTarget) setMenuOpen(false)
  }
  const handleGoTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  const handleOnScroll = () => {
    if (window.scrollY >= 450) {
      setShowGoTop(true)
    } else {
      setShowGoTop(false)
    }
  }
  const renderActiveClass = ({ isActive }) =>
    `${isActive ? isMatchSub ? 'active' : 'active disabled' : ''}`

  useEffect(() => {
    document.body.style = menuOpen && `overflow: hidden`
    window.addEventListener('scroll', handleOnScroll)
    return () => {
      window.removeEventListener('scroll', handleOnScroll)
    }
  }, [menuOpen])

  const renderMobileSocial = (Tag = 'div') => (
    <Tag className={styles.mobileSocial}>
      <Link to={SOCIAL_URL.LINE} target='_blank' rel='noopener'>
        <img src={lineIconColor} alt="colored line icon" />
      </Link>
      <Link to={SOCIAL_URL.INSTAGRAM} target='_blank' rel='noopener'>
        <img src={igIconColor} alt="colored ig icon" />
      </Link>
    </Tag>
  )

  const HIDE_KEYS = ['COURSE'] // 要隱藏的 route key

  const filteredRoutes = routes.filter(key => !HIDE_KEYS.includes(key))


  return (
    <div
      className={classNames(styles.container, menuOpen && styles.open)}
      onClick={handleMenuClose}
    >
      <nav className={classNames(styles.navbar)}>
        <div className={styles.navInner}>
          <Link to="/home" className={styles.logo} onClick={menuOpen && handleMenuClose}>
            <Logo />
          </Link>
          <ul>
            {filteredRoutes.map(routeKey => (
              <li key={routeKey}>
                <NavLink
                  to={`/${ROUTE_MAP[routeKey].key}`}
                  className={renderActiveClass}
                  onClick={menuOpen && handleMenuClose}
                >
                  {ROUTE_MAP[routeKey].title}
                </NavLink>
              </li>
            ))}
            {renderMobileSocial('li')}
          </ul>
          <button className={styles.menuButton} onClick={handleMenuIconClick}>
            {menuOpen ? <CrossIcon /> : <MenuIcon />}
          </button>
        </div>
      </nav>
      <Outlet />
      <div className={classNames(styles.goTop, showGoTop && styles.show)} onClick={handleGoTop}>
        <img src={goTop} alt='go top button' />
      </div>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>

          <div className={styles.footerRow}>
            <Link to="/" className={styles.logo}>
              <img src={favicon} alt="logo" />
              澧曜數據 LIYAO
            </Link>

            <div className={styles.social}>
              <Link
                to={SOCIAL_URL.INSTAGRAM}
                target="_blank"
                rel="noopener"
                className={styles.iconLink}
              >
                <img src={igDefault} alt="Instagram" className={styles.iconDefault} />
                <img src={igHover} alt="Instagram hover" className={styles.iconHover} />
              </Link>

              <Link
                to={SOCIAL_URL.FB}
                target="_blank"
                rel="noopener"
                className={styles.iconLink}
              >
                <img src={fbDefault} alt="Facebook" className={styles.iconDefault} />
                <img src={fbHover} alt="Facebook hover" className={styles.iconHover} />
              </Link>

              <Link
                to={SOCIAL_URL.YOUTUBE}
                target="_blank"
                rel="noopener"
                className={`${styles.iconLink} ${styles.ytIcon}`}
              >
                <img src={ytDefault} alt="YouTube" className={styles.iconDefault} />
                <img src={ytHover} alt="YouTube hover" className={styles.iconHover} />
              </Link>
            </div>
          </div>

          <div className={styles.footerRow}>
            <div className={styles.infoItem}>
              <Link to={SOCIAL_URL.ADDRESS_MAP} target='_blank' rel='noopener'>
                <img src={addressIcon} alt="Address" className={styles.icon} />
              </Link>
              {SOCIAL_URL.ADDRESS}
            </div>
            <div className={styles.infoItem}>
              <img src={serviceIcon} alt="Service" className={styles.icon} />
              服務時間 {SOCIAL_URL.SERVICE_TIME}
            </div>
          </div>

          <div className={styles.footerRow}>
            <div className={styles.infoItem}>
              <Link to={SOCIAL_URL.LINE} target='_blank' rel='noopener'>
                <img src={lineIconColor} alt="Line" className={styles.icon} />
              </Link>
              {SOCIAL_URL.LINE_ACCOUNT}
            </div>
            <div className={styles.infoItem}>
              <img src={emailIcon} alt="Email" className={styles.icon} />
              {SOCIAL_URL.EMAIL}
            </div>
          </div>

          <div className={styles.footerRow}>
            <div />
            <div>Copyright © 2024 liyaodata All rights reserved.</div>
          </div>

        </div>
      </footer>




    </div>
  )
}

export default NavWrapper
